import { Entity, Field } from "typegraph";

class Type {
    @Field()
    public name: string;

    @Field()
    public id: string;
}

class ValueResult {
	@Field()
	public value: number;

	@Field()
	public completedOn: string;

    @Field({entity: Type})
    public type: Type
}

@Entity({many: "creditEntriesUser"})
export class CreditEntriesUser {
	@Field()
	public value: number;

	@Field()
	public completedOn: string;

    @Field({entity: Type})
    public type: Type
}

@Entity({one: "creditEntriesUserCount"})
export class CreditUserCount {
	@Field()
	public count: number;
}




// WEBPACK FOOTER //
// ./src/panels/creditSummary/CreditSummary.ts